import { Injectable } from '@angular/core';
import { SubscriptionCompService } from '@savvy/subscription';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/** Subscription feature code that grants the WhatsApp channel. */
export const WHATSAPP_CHANNEL_FEATURE = 'WHATSAPP_CHANNEL';

/**
 * Whether the organisation's plan or add-ons include the WhatsApp channel.
 * Fails closed: if the features cannot be loaded the channel stays hidden.
 */
@Injectable({ providedIn: 'root' })
export class WhatsAppChannelAccessService {
  constructor(private subscriptionCompService: SubscriptionCompService) { }

  isAllowed(contextId: string, contextIdType: string): Observable<boolean> {
    return this.subscriptionCompService.allowedFeatures(contextId, contextIdType as any).pipe(
      map(features => (features || []).some(feature => (feature.type as string) === WHATSAPP_CHANNEL_FEATURE)),
      catchError(() => of(false)));
  }
}
